'use client'

import clsx from 'clsx'
import React from 'react'
import { ChevronRight } from 'react-feather'

import { EventType } from '@/core/graphql/types'

import { timeSince } from './utils'

export type EventProps = {
  id: string
  createdAt?: string | Date | null
  userId: string
  onNotificationClick: (eventId: string) => void
  type: {
    label: string
    value: string
  }
  recipients: Array<{
    read?: boolean | null
    userId: string
  }>
}

export default function Event(props: EventProps) {
  const { id, createdAt, userId: authUserId, onNotificationClick, type, recipients } = props

  const displayEventType = () => {
    switch (type.value) {
      case EventType.ConsultationInvitation:
        return 'Consultation Invitation'
      case EventType.ConsultationReminder:
        return 'Consultation Reminder'
      case EventType.EmergencyInvite:
        return 'Emergency Invite'
      case EventType.ExpertiseCreated:
        return 'Expertise Created'
      case EventType.ExpertiseUpdated:
        return 'Expertise Updated'
      case EventType.OrderCreated:
        return 'Order Created'
      case EventType.OrderReminder:
        return 'Order Reminder'
      case EventType.OrderUpdated:
        return 'Order Updated'
      default:
        return 'Unknown Event'
    }
  }

  const isRead = () => {
    return recipients.find((recipient) => recipient.userId === authUserId)?.read
  }

  const unread = !isRead()

  return (
    <li>
      <a
        onClick={() => onNotificationClick(id)}
        className="group flex w-full cursor-pointer items-center gap-3 py-3 transition-colors"
      >
        {/* Unread indicator — kept (transparent when read) so rows stay aligned */}
        <span className={clsx('flex-none', unread ? 'text-green-400' : 'text-transparent')} aria-hidden="true">
          <span className="block h-2 w-2 rounded-full bg-current" />
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <h3 className={clsx('truncate text-sm leading-6 text-gray-800', unread ? 'font-semibold' : 'font-medium')}>{displayEventType()}</h3>
            <span className="flex-none text-xs text-gray-400">{timeSince(createdAt)}</span>
          </div>
          <p className="truncate text-sm text-gray-500">{type.label}</p>
        </div>

        <ChevronRight size={20} className="flex-none text-gray-300 transition-colors group-hover:text-gray-500" aria-hidden="true" />
      </a>
    </li>
  )
}
